<template>
  <div class="triangle" />
</template>

<style scoped>
.triangle {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 220px 90px 0 0;
  border-color: #8ec044 transparent transparent transparent;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1000;
  display: none;
}

@media only screen and (min-width: 940px) {
  .triangle {
    display: block;
  }
}
</style>
